import React from 'react';
import Susan from "../AllImages/Susan.jpeg";
import Luis from "../AllImages/Luis.jpg";
import Ruben from "../AllImages/Rubenn.png";
import Discord from "../AllImages/Diiiscord.jpg";

const OnlineSectionals = () => {
  return (
    <div className="bg-gray-900 min-h-screen text-gray-100 py-8 px-4">
      <div className="max-w-7xl mx-auto">
        {/* Intro Text */}
        <p className="mb-8 text-xl text-center text-gray-300">
          Before the tour starts, we will be hosting online sectionals with all the members of the orchestras.
        </p>

        {/* Two-Column Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          
          {/* Strings Rehearsal Box */}
          <div className="bg-gray-800 border border-gray-700 rounded-lg shadow-md">
            <div className="p-6">
              <h2 className="text-2xl font-bold text-amber-400 mb-6 text-center">
                Strings Rehearsal
              </h2>
              
              {/* October 4th - Susan Teacher */}
              <div className="flex items-start mb-6">
                <div className="relative mr-4">
                  <img
                    src={Susan}
                    alt="Susan Teacher"
                    className="w-14 h-14 object-cover rounded-full border-2 border-gray-600 shadow-md"
                  />
                  <img
                    src={Discord}
                    alt="Special Guest"
                    className="w-8 h-8 object-cover rounded-full border-2 border-gray-800 shadow-md absolute -bottom-1 -right-1"
                  />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-100 mb-1">
                    October 4th <span className="text-sm text-gray-400">(Susan Teacher)</span>
                  </h3>
                  <ul className="list-disc list-inside ml-4 text-sm text-gray-300">
                    <li>Violins: 12-2pm ( Central Time Zone)</li>
                    <li>Violas: 3-4pm ( Central Time Zone)</li>
                    <li>Cellos + Basses: 5-6pm ( Central Time Zone)</li>
                  </ul>
                </div>
              </div>
              
              {/* October 13th - Luis Teacher Competition Workshop */}
              <div className="flex items-start mb-6">
                <div className="relative mr-4">
                  <img
                    src={Luis}
                    alt="Luis Teacher"
                    className="w-14 h-14 object-cover rounded-full border-2 border-gray-600 shadow-md"
                  />
                  <img
                    src={Discord}
                    alt="Special Guest"
                    className="w-8 h-8 object-cover rounded-full border-2 border-gray-800 shadow-md absolute -bottom-1 -right-1"
                  />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-100 mb-1">
                    October 13th{" "}
                    <span className="text-sm text-gray-400">(Luis Teacher) Competition Workshop</span>
                  </h3>
                  <ul className="list-disc list-inside ml-4 text-sm text-gray-300">
                    <li>Violins: 12-2pm ( Central Time Zone)</li>
                    <li>Violas: 3-4pm ( Central Time Zone)</li>
                    <li>Cellos + Basses: 5-6pm ( Central Time Zone)</li>
                  </ul>
                </div>
              </div>
              
              {/* October 20th - Susan Teacher + Special Guest Competition Workshop */}
              <div className="flex items-start">
                <div className="relative mr-4">
                  <img
                    src={Susan}
                    alt="Susan Teacher"
                    className="w-14 h-14 object-cover rounded-full border-2 border-gray-600 shadow-md"
                  />
                  <img
                    src={Discord}
                    alt="Special Guest"
                    className="w-8 h-8 object-cover rounded-full border-2 border-gray-800 shadow-md absolute -bottom-1 -right-1"
                  />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-100 mb-1">
                    October 20th{" "}
                    <span className="text-sm text-gray-400">
                      (Susan Teacher + Special Guest + Competition Workshop)
                    </span>
                  </h3>
                  <ul className="list-disc list-inside ml-4 text-sm text-gray-300">
                    <li>Violins: 12-2pm ( Central Time Zone)</li>
                    <li>Violas: 3-4pm ( Central Time Zone)</li>
                    <li>Cellos + Basses: 5-6pm ( Central Time Zone)</li>
                  </ul>
                </div>
              </div>

              {/* Button and Discord Link */}
              <div className="mt-6 text-center">
                <a
                  href="https://us06web.zoom.us/j/85612150648?pwd=5PEFJ3DfH8SojXqDabsjbr3fN9X0Df.1"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button className="bg-amber-400 hover:bg-amber-500 text-gray-900 font-bold py-2 px-4 rounded-full">
                    Enter Rehearsal
                  </button>
                </a>
              
              </div>
            </div>
          </div>

          {/* Winds + Percussion Rehearsal Box */}
          <div className="bg-gray-800 border border-gray-700 rounded-lg shadow-md">
            <div className="p-6">
              <h2 className="text-2xl font-bold text-amber-400 mb-6 text-center">
                Winds + Percussion Rehearsal
              </h2>
              
              {/* October 4th - Ruben Teacher */}
              <div className="flex items-start mb-6">
                <div className="relative mr-4">
                  <img
                    src={Luis}
                    alt="Luis Teacher"
                    className="w-14 h-14 object-cover rounded-full border-2 border-gray-600 shadow-md"
                  />
                  <img
                    src={Discord}
                    alt="Special Guest"
                    className="w-8 h-8 object-cover rounded-full border-2 border-gray-800 shadow-md absolute -bottom-1 -right-1"
                  />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-100 mb-1">
                    October 4th <span className="text-sm text-gray-400">(Luis Teacher)</span>
                  </h3>
                  <ul className="list-disc list-inside ml-4 text-sm text-gray-300">
                    <li>Woodwinds: 12-2pm ( Central Time Zone)</li>
                    <li>Brass: 3-4pm ( Central Time Zone)</li>
                    <li>Percussion + Basses: 5-6pm ( Central Time Zone)</li>
                  </ul>
                </div>
              </div>
              
              {/* October 13th - Luis Teacher Competition Workshop */}
              <div className="flex items-start mb-6">
                <div className="relative mr-4">
                  <img
                    src={Ruben}
                    alt="Ruben Teacher"
                    className="w-14 h-14 object-cover rounded-full border-2 border-gray-600 shadow-md"
                  />
                  <img
                    src={Discord}
                    alt="Special Guest"
                    className="w-8 h-8 object-cover rounded-full border-2 border-gray-800 shadow-md absolute -bottom-1 -right-1"
                  />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-100 mb-1">
                    October 13th{" "}
                    <span className="text-sm text-gray-400">(Ruben Teacher) Competition Workshop</span>
                  </h3>
                  <ul className="list-disc list-inside ml-4 text-sm text-gray-300">
                    <li>Woodwinds: 12-2pm ( Central Time Zone)</li>
                    <li>Brass: 3-4pm ( Central Time Zone)</li>
                    <li>Percussion + Basses: 5-6pm ( Central Time Zone)</li>
                  </ul>
                </div>
              </div>
              
              {/* October 20th - Ruben Teacher + Special Guest Competition Workshop */}
              <div className="flex items-start">
                <div className="relative mr-4">
                  <img
                    src={Ruben}
                    alt="Ruben Teacher"
                    className="w-14 h-14 object-cover rounded-full border-2 border-gray-600 shadow-md"
                  />
                  <img
                    src={Discord}
                    alt="Special Guest"
                    className="w-8 h-8 object-cover rounded-full border-2 border-gray-800 shadow-md absolute -bottom-1 -right-1"
                  />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-100 mb-1">
                    October 20th{" "}
                    <span className="text-sm text-gray-400">
                      (Ruben Teacher + Special Guest + Competition Workshop)
                    </span>
                  </h3>
                  <ul className="list-disc list-inside ml-4 text-sm text-gray-300">
                    <li>Woodwinds: 12-2pm ( Central Time Zone)</li>
                    <li>Brass: 3-4pm ( Central Time Zone)</li>
                    <li>Percussion + Basses: 5-6pm ( Central Time Zone)</li>
                  </ul>
                </div>
              </div>

              {/* Button and Discord Link */}
              <div className="mt-6 text-center">
                <a
                  href="https://zoom.us/j/92022746426?pwd=HD3lapeMpLYYcwc7bVVUKbOmJhG8KT.1"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button className="bg-amber-400 hover:bg-amber-500 text-gray-900 font-bold py-2 px-4 rounded-full">
                    Enter Rehearsal
                  </button>
                </a>
             
              </div>
            </div>
          </div>
          
        </div> {/* End of Grid */}
      </div> {/* End of Container */}
    </div>
  );
};

export default OnlineSectionals;
